import { Box, Button, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { useState, useEffect } from 'react'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { Item } from '../../../common/snippets'
import { summaryHeaderColumn } from './HisabConstant'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import moment from 'moment'
import { focusElemnt, navigation3 } from '../../../common/helper'
const SummaryReport = ({ reportData, vehicleNo, loginData, toDate, fromDate }) => {
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load } = { ...state }
  const [isPdfLoading, setIsPdfLoading] = useState(true)
  const [tableData, setTableData] = useState([])
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
  useEffect(() => {
    if (reportData.length > 0) {
      setTableData(reportData)
    } else {
      setTableData([])
    }
  }, [reportData])
  const SecontInsideRowContent = ({ item, index, fontVal }) => {
    return (
      <>
        <TableRow>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
            >
              {item.HisabNo}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left', borderRadius: '30px' }}
            >
              {item.HisabDate}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
            >
              {item.Amount}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.Comm}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
            >
              {item.GeneratedBy}
            </TableCell>
          </>
        </TableRow>
      </>
    )
  }
  const generatepdf = (isSave) => {
    setIsPdfLoading(false)
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const HeaderColumn = [
      {
        headerName: 'Vehicle No.',
        exportHead: 'Vehicle No.',
        field: 'vehicleNo',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
    ]
    const HeaderColumns = HeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfColumns = summaryHeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const doc = new jsPDF({ orientation: 'p', format: [1080, 1528], unit: 'px' })
    doc.autoTableSetDefaults({
      headStyles: { fontSize: 6, width: 'auto', halign: 'right', fillColor: [30, 89, 167] },
    })
    var totalPagesExp = '{total_pages_count_string}'
    const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
      const doc = data.doc
      // Footer
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

      var str = 'Page : ' + doc.internal.getNumberOfPages()
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }
      doc.setFontSize(16)
      doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, 'right')
      doc.setFont('Roboto', 'bold')
      doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
      // doc.text(`Report By : Akash Vaibhav`, 30, pageHeight - 5)
      doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, doc.internal.pageSize.width / 2 - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize()) / 2 + 90, pageHeight - 5)
    }
    doc.setProperties({
      title: `Item List.pdf`,
      subject: 'Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })

    autoTable(doc, {
      margin: { top: 180, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: [{ vehicleNo: vehicleNo?.VehicleNo}],
      columnStyles: {
        0: {
          fontSize: 18,
          font: 'Roboto',
          valign: 'middle',
          minCellHeight: 24,
          halign: 'left',
          minCellHeight: 36,
          cellPadding: 12,
          fontStyle: 'normal',
          textColor: [0, 0, 0],
        },
      },
      theme: 'grid',
      showHead: 'everyPage',
      headStyles: {
        halign: 'left',
        valign: 'middle',
        cellPadding: 12,
        fontSize: 18,
        minCellHeight: 36,
        fillColor: [182, 222, 254],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        font: 'Roboto',
        lineWidth: 0.6,
      },
    })

    autoTable(doc, {
      margin: { top: 180, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: pdfColumns,
      body: tableData,
      columnStyles: {
        0: { halign: 'left', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
        1: { halign: 'left', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
        2: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
        3: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
        4: { halign: 'left', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
      },
      theme: 'grid',
      styles: {
        lineWidth: [0, 0.2, 0, 0.6],
      },
      tableLineWidth: 0.6,
      headStyles: {
        fontSize: 16,
        fillColor: [218, 237, 254],
        textColor: [0, 0, 0],
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'normal',
        minCellHeight: 36,
        font: 'Roboto',
      },
      didParseCell: (data) => {
        if (data.row.section === 'head') {
          if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
            data.cell.styles.halign = 'right'
          } else {
            data.cell.styles.halign = 'left'
          }
        }
        // drawCell(data)
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18)
        doc.setFont('Roboto', 'bold')
        doc.text(`Report View: Summary`, 910, 170)
        doc.setFontSize(18)
        doc.setFont('Roboto', 'bold')
        doc.text(`Booking Date :${moment(fromDate).format('DD-MMM-YYYY')} To ${moment(toDate).format('DD-MMM-YYYY')}`, 30, 170)
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System | Generate Hisab Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont('Roboto', 'bold')
        doc.text(`Company Name : ${loginData?.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })
    doc.setFont('Roboto')
    // if (typeof doc.putTotalPages === 'function') {
    //   doc.putTotalPages(totalPagesExp)
    // }
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Own ${'Booking'} Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('hisabReportSummary').data = pdfUrl
        // document.getElementById('hisabReportSummary').data = doc.output('datauristring', 'GenerateHisab Summary  Report')
        focusElemnt("HisabBackBtn")
      }, 2000)
    }
    setTimeout(() => {
      setState({ ...state, generatePDF: false, load: true })
      const pdfUrl = doc.output('bloburl')
        document.getElementById('hisabReportSummary').data = pdfUrl
      // document.getElementById('hisabReportSummary').data = doc.output('datauristring', 'GenerateHisab Summary Report.pdf')
      focusElemnt("HisabBackBtn")
    }, 2000)
  }
  return (
    <>
      <Box sx={{ ...sx.reportFlex, justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
        <Typography variant="h5" display="block" sx={{ fontWeight: 600, color: '#444' }}>
          Report For: Generate Hisab Report
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center' }} className="itemButtons">
          {isPdfLoading ? (
            <>
              <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "HisabGeneratePdfBtn", 'SplitBtn', () => { })}>
                <ReactHtmlTableToExcel
                  id="test-table-xls-button"
                  className="receiveitemExcelBtn"
                  table="table-to-xls"
                  filename={`GenerateHisab Summary Report ${currentDateTime}`}
                  sheet="tablexls"
                  buttonText="Export to Excel"
                />
              </Item>
              <Item sx={sx.itemsx} className="disabled-wrapper">
                <Button
                  id='HisabGeneratePdfBtn'
                  variant="outlined"
                  sx={{ width: '100%' }}
                  className="receiveitembtn"
                  onClick={() => { generatepdf(true) }}
                  onKeyDown={(e) => navigation3(e, "HisabGeneratePrintBtn", "test-table-xls-button", () => { generatepdf(true) })}
                >
                  Export As PDF
                </Button>
              </Item>
              <Item sx={sx.itemsx} className="disabled-wrapper">
                <Button
                  id='HisabGeneratePrintBtn'
                  variant="outlined"
                  sx={{ width: '100%' }}
                  className="receiveitembtn"
                  onClick={() => {
                    generatepdf(false)
                  }}
                  onKeyDown={(e) => navigation3(e, "fromDate", "HisabGeneratePdfBtn", () => { generatepdf(false) })}
                >
                  Print
                </Button>
              </Item>
            </>
          ) : (
            <Item sx={sx.itemsx} className="disabled-wrapper">
              <Button id='HisabBackBtn' variant="outlined" sx={{ width: '100%' }} className="receiveitembtn" onClick={() => setIsPdfLoading(true)} onKeyDown={(e) => navigation3(e, 'fromDate', 'SplitBtn', () => { setIsPdfLoading(true); focusElemnt('SplitBtn') })}>
                Back
              </Button>
            </Item>
          )}
        </Box>
      </Box>
      {isPdfLoading ? (
        <>
          <Stack sx={{ marginLeft: 2, marginRight: 2, height: 480, paddingTop: '10px' }}>
            <TableContainer style={{ border: '1px solid #aeaeae', borderRadius: '12px' }} className="scroll">
              <Table className="table1 table-Report" size="small" aria-label="a dense table">
                <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
                  <TableRow>
                    <TableCell
                      className="reportTD"
                      style={{
                        fontWeight: 'bold',
                        fontSize: '14px',
                        lineheight: '16px',
                        letterspacing: '0.24px',
                        fontWeight: '700',
                        textAlign: 'left',
                        color: '#444444',
                        backgroundColor: '#bfe1ff',
                        height: '36px',
                      }}
                      colSpan={5}
                    >
                      Vehicle No :{vehicleNo?.VehicleNo}
                      {/* Source City:{sourceCity?.SourceCityName} */}
                    </TableCell>
                  </TableRow>
                  <TableRow style={{ color: 'white' }}>
                    {summaryHeaderColumn?.map((item, i) => (
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#e5f3ff',
                          color: '#454646',
                          fontSize: '14px',
                          fontWeight: '500',
                          textAlign: item.align,
                          height: '36px',
                        }}
                        colSpan={item.col}
                        key={i}
                      >
                        {item.headerName}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                {tableData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={5}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '12px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '12px',
                              lineheight: '16px',
                              letterspacing: '0.24px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : tableData?.length >= 1 ? (
                  <TableBody
                    className="filter-data-row"
                    style={{
                      textAlign: 'center',
                      fontSize: '12px',
                      lineheight: '16px',
                      letterspacing: '0.24px',
                      fontWeight: '500',
                      marginLeft: '5px',
                    }}
                  >
                    {tableData?.map((item, index) => (
                      <SecontInsideRowContent item={item} index={index} key={index} fontVal={'12px'} />
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
              <Table style={{ display: 'none' }} id="table-to-xls" className="table1 table-Report" size="small" aria-label="a dense table">
                <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
                  <TableRow>
                    <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'left' }} colSpan={2}>
                      <h3>Report For: Generate Hisab Report</h3>
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'right' }} colSpan={3}>
                      <h3>Company Name : _Maven Tech Services Pvt. Ltd.</h3>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={5}></TableCell>
                  </TableRow>
                  <TableRow style={{ color: 'white' }}>
                    <TableCell
                      className="ReportItemHead"
                      style={{ backgroundColor: '#e5f3ff', color: '#444', fontSize: '20px', fontWeight: '600', textAlign: 'left' }}
                      colSpan={5}
                    >
                      Vehicle No.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={5}
                    >
                      {vehicleNo?.VehicleNo}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={5}></TableCell>
                  </TableRow>
                </TableHead>
                <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
                  <TableRow>
                    <TableCell
                      className="reportTD"
                      style={{
                        fontWeight: 'bold',
                        fontSize: '20px',
                        lineheight: '16px',
                        letterspacing: '0.24px',
                        fontWeight: '700',
                        textAlign: 'left',
                        color: '#444444',
                        backgroundColor: '#bfe1ff',
                        height: '36px',
                      }}
                      colSpan={5}
                    >
                      Vehicle No {vehicleNo?.VehicleNo}
                      {/* Source City:{sourceCity?.SourceCityName} */}
                    </TableCell>
                  </TableRow>
                  <TableRow style={{ color: 'white' }}>
                    {summaryHeaderColumn?.map((item, i) => (
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#e5f3ff',
                          color: '#444',
                          fontSize: '20px',
                          fontWeight: '600',
                          textAlign: item.align,
                          height: '36px',
                        }}
                        colSpan={item.col}
                        key={i}
                      >
                        {item.headerName}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                {tableData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={5}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '12px',
                              lineheight: '16px',
                              letterspacing: '0.24px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : tableData?.length >= 1 ? (
                  <TableBody
                    className="filter-data-row"
                    style={{
                      textAlign: 'center',
                      fontSize: '12px',
                      lineheight: '16px',
                      letterspacing: '0.24px',
                      fontWeight: '500',
                      marginLeft: '5px',
                    }}
                  >
                    {tableData?.map((item, index) => (
                      <SecontInsideRowContent item={item} index={index} key={index} fontVal={'20px'} />
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
            </TableContainer>
          </Stack>
        </>
      ) : (
        <>
          {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          {load ? (
            <object
              id="hisabReportSummary"
              type="application/pdf"
              width="100%"
              height="440"
              title="MTLPL -Cargo System - GenerateHisab Summary Report "
              aria-label="MTLPL -Cargo System - GenerateHisab Summary  Report"
            ></object>
          ) : (
            ''
          )}
        </>
      )}
    </>
  )
}

export default SummaryReport
